module.exports = __webpack_public_path__ + "static/certyfikat_WSK_ang-986a2d8524b1fbbc929659e0f9ef2fba.pdf";